<template>
  <div class="row">
    <div class="col-12 card">
      <form
        id="search-filter-orw"
        method="POST"
        @submit.prevent="callPCSServices"
      >
        <div class="row m-1">
          <div class="col-md-3">
            <div class="form-group">
              <label class="text-sm">Organization</label>
              <select
                class="form-control form-control-sm"
                name="OrgID"
                v-model="organization_id"
                @change="callCitiesByOrgID(organization_id)"
              >
                <option value="">-</option>
                <option v-for="org in organizations" :value="org.ID">
                  {{ org.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="city">City</label>
              <select
                name=""
                id="city"
                class="form-control form-control-sm"
                v-model="city_id"
                @change="callAreaByCityID(city_id)"
              >
                <option value="" selected>Select City</option>
                <option v-for="city in cities" :value="city.ID">
                  {{ city.CityName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label
                ><small><b>Employee Code</b></small></label
              >
              <select
                class="form-control form-control-sm"
                name="EmployeeID"
                v-model="employee_id"
              >
                <option value="">-</option>
                <option v-for="employee in employees" :value="employee.ID">
                  {{ employee.EmployeeCode }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="text-sm">Form No</label>
              <input
                type="text"
                class="form-control form-control-sm"
                name="FormNo"
                v-model="form_no"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="text-sm">Date From</label>
              <input
                type="date"
                class="form-control form-control-sm"
                name="DateFrom"
                v-model="date_from"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="text-sm">Date To</label>
              <input
                type="date"
                class="form-control form-control-sm"
                name="DateTo"
                v-model="date_to"
              />
            </div>
          </div>
          <div class="offset-8 col-md-2">
            <div class="form-group">
              <button
                type="submit"
                name="btnSearch"
                class="btn btn-secondary btn-sm pl-4 pr-4 btn-nz"
                v-on:click="btnSearch = true"
              >
                Search
              </button>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <button
                type="button"
                name="btnSearch"
                class="btn btn-secondary btn-sm pl-4 pr-4"
                v-on:click="
                  btnSearch = false;
                  callPCSServices();
                "
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Prevention Counseling Services</h3>
          <a
            href="/cocp-plus/prevention-counseling/create"
            class="btn btn-primary btn-nz float-right" v-if="canAddRecord"
            >Add Record</a
          >
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <advanced-laravel-vue-paginate
            :data="services"
            @paginateTo="callPCSServices"
            alignment="left"
          />
          <div class="table-responsive table-scroller mb-3">
            <table
              id="example2"
              class="
                table table-sm table-bordered
                nowrap
                table-hover
                text-nowrap
                table-head-fixed
              "
            >
              <thead>
                <tr>
                  <!-- <th>SerialNo.</th> -->
                  <th>Actions</th>
                  <th>Form No.</th>
                  <th>Organization</th>
                  <th>City</th>
                  <th>Employee</th>
                  <th>Date</th>
                  <th>Created By</th>
                  <th>Date Creation</th>
                  <th>Last Modification By</th>
                  <th>Last Modification Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in services.data" :key="index">
                  <!-- <td>{{ index + 1 }}</td> -->
                  <td>
                    <a
                      v-if="service.can_edit"
                      title="Edit"
                      class=""
                      :href="'prevention-counseling/' + service.id + '/edit'"
                    >
                      <i class="fa fa-edit"></i
                    ></a>
                    <a
                      v-if="service.can_view"
                      title="View"
                      class=""
                      :href="'prevention-counseling/' + service.id"
                    >
                      <i class="fa fa-eye"></i
                    ></a>
                    <a
                      v-if="service.can_delete"
                      href="#"
                      data-toggle="modal"
                      data-target="#modal-delete-service"
                      class="delete_service"
                      :data-id="service.id"
                      data-model="PreventionCounselingService"
                      data-type="ticket"
                      ><i class="fa fa-trash"></i
                    ></a>
                  </td>
                  <td>{{ service.form_no }}</td>
                  <td>{{ service.organization }}</td>
                  <td>{{ service.city }}</td>
                  <td>{{ service.employee }}</td>
                  <td>{{ service.date }}</td>
                  <td>{{ service.created_by }}</td>
                  <td>{{ service.created_at }}</td>
                  <td>{{ service.modified_by }}</td>
                  <td>{{ service.modified_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <advanced-laravel-vue-paginate
            :data="services"
            @paginateTo="callPCSServices"
            alignment="left"
          />
        </div>

        <!-- /.card-body -->
      </div>
    </div>
    <!-- /.col -->
  </div>
</template>

<script>
export default {
  props: [
    "canAddRecord"
  ],
  data() {
    return {
      services: {},
      form_no: null,
      organization_id: null,
      organizations: null,
      employees: null,
      employee_id: null,
      cities: null,
      errored: false,
      loading: false,
      city_id: null,
      date_from: null,
      date_to: null,
      btnSearch: false,
    };
  },
  methods: {
    submitOrwFilterForm(page = 1) {
      this.loader = true;
    },
    callPCSServices(page = 1) {
      var data = null;

      if (this.btnSearch) {
        data = {
          OrganizationID: this.organization_id,
          EmployeeID: this.employee_id,
          CityID: this.city_id,
          FormNo: this.form_no,
          DateFrom: this.date_from,
          DateTo: this.date_to,
          btnSearch: this.btnSearch,
        };
      } else {
        this.organization_id = null;
        this.employee_id = null;
        this.city_id = null;
        this.form_no = null;
        this.date_from = null;
        this.date_to = null;
      }
      axios
        .post("services/prevention-counseling?page=" + page, data)
        .then((response) => {
          console.log(response.data);
          this.services = response.data;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    callCitiesByOrgID(org_id) {
      axios
        .get("org-cities/" + org_id)
        .then((response) => {
          this.cities = response.data;
          console.log(this.cities);
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    callOrganization() {
      axios
        .get("organizations_list")
        .then((response) => {
          this.organizations = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    callEmployeesList() {
      axios
        .get("employees_list" + "?type=VCCT Counseller")
        .then((response) => {
          this.employees = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.callPCSServices();
    this.callOrganization();
    this.callEmployeesList();
  },
};
</script>

<style lang="scss" scoped>
</style>